import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HomeCareUploadedDocumentationTypeEnum {
    None = 0,
    SingleVisit = 1,
    BulkVisit = 2
}

class HomeCareUploadedDocumentationTypeClass extends EnumWithDescription<HomeCareUploadedDocumentationTypeEnum> {
    public readonly enum = HomeCareUploadedDocumentationTypeEnum;
    public readonly enumName: string = "HomeCareUploadedDocumentationTypeEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HomeCareUploadedDocumentationTypeEnum>> =
        new Map([
            [
                "None",
                {
                    name: "None",
                    value: HomeCareUploadedDocumentationTypeEnum.None
                }
            ],
            [
                "SingleVisit",
                {
                    name: "SingleVisit",
                    value: HomeCareUploadedDocumentationTypeEnum.SingleVisit,
                    longDescription: "Include in claim/invoice documentation"
                }
            ],
            [
                "BulkVisit",
                {
                    name: "BulkVisit",
                    value: HomeCareUploadedDocumentationTypeEnum.BulkVisit,
                    longDescription: "Bulk claim/invoice documentation"
                }
            ]
        ]);
}

export const homeCareUploadedDocumentationType = new HomeCareUploadedDocumentationTypeClass();
